import {APIPromise, easasAxios, requestPromiseTypeWrapper} from "../services/HttpService";
import {AxiosInstance} from 'axios'
import {IConfig, ITableDataEntry} from "../components/dashboard/product-template-table/utils/interfaces";
import {
    filterPreviewValidation,
    getDataStringParamsToObject
} from "../components/dashboard/product-template-table/utils/utils";
import {IProductTemplateInfoDTO} from "./model/product-template/IProductTemplateInfoDTO";

const API_SCOPE = "/productTemplates";

const promise = requestPromiseTypeWrapper;

class ProductTemplatesApiDefinition {
    private httpClient: AxiosInstance;

    constructor() {
        console.log("ProductTemplatesApi obj created!")
        this.httpClient = easasAxios;
    }

    async getProductTemplateInfos(): APIPromise<IProductTemplateInfoDTO[]> {
        return promise(this.httpClient.get(`${API_SCOPE}/infos`))
    }

    async getProductTemplateInfo(id: number | null): APIPromise<IProductTemplateInfoDTO> {
        if(id == null) return {data: undefined};

        return promise(this.httpClient.get(`${API_SCOPE}/infos/${id}`))
    }

    async getProductTemplateConfig(refName: string): APIPromise<IConfig> {
        return promise(this.httpClient.get(`${API_SCOPE}/${refName}/config`))
    }

    async getProductTemplateData(params:{safeName: string, dateFrom?:string, dateTo?:string, filter?: string}): APIPromise<Array<ITableDataEntry>> {
        return promise(this.httpClient.get(`${API_SCOPE}/${params.safeName}/data`, getDataStringParamsToObject(params.dateFrom, params.dateTo, params.filter)))
    }

    async getProductTemplateDataFilterPreview(params:{safeName: string, dateFrom?:string, dateTo?:string, filter?: string}): APIPromise<Array<ITableDataEntry>> {
        return promise(this.httpClient.get(`${API_SCOPE}/${params.safeName}/filter-preview`, filterPreviewValidation(params.dateFrom, params.dateTo, params.filter)))
    }

    async getProductTemplateForeignKeys(template: string): APIPromise<any> {
        return promise(this.httpClient.get(`${API_SCOPE}/${template}/asForeignKeys`))
    }


    async deleteProductTemplateEntry(template: string, entryId: string): APIPromise<any> {
        return promise(this.httpClient.delete(`${API_SCOPE}/${template}/${entryId}`))
    }

    async updateProductTemplateEntry(params:{safeName: string, entryId:string, body:any}): APIPromise<any> {
        return promise(this.httpClient.patch(`${API_SCOPE}/${params.safeName}/${params.entryId}`, params.body))
    }

    async createProductTemplateEntry(template: string, entryBody: any): APIPromise<any> {
        return promise(this.httpClient.post(`${API_SCOPE}/${template}/data`, entryBody))
    }

    async signProductTemplateEntry(template: string, entryId: string, referenceName: string): APIPromise<any> {
        return promise(this.httpClient.put(`${API_SCOPE}/${template}/${entryId}/${referenceName}/sign`))
    }

    async deleteProductTemplateEntriesByFilter(templateRef: string, params:{dateFrom?:string, dateTo?:string, filter?: string}): APIPromise<any> {
        return promise(this.httpClient.delete(`${API_SCOPE}/${templateRef}/delete-by-filter`, filterPreviewValidation(params.dateFrom, params.dateTo, params.filter)))
    }

    async wipeAllProductTemplateEntries(templateRef: string): APIPromise<any> {
        return promise(this.httpClient.delete(`${API_SCOPE}/${templateRef}/wipe-all`))
    }
}

export const ProductTemplatesApi = new ProductTemplatesApiDefinition();